import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import { SeoService } from './seo.service';

/**
 * Reads `title` and `description` from the route data of the deepest activated
 * route and hands them to the {@link SeoService}.
 *
 * The title comes from `data.title` rather than Angular's `Route.title`
 * property: that is the convention already used across these routes, and the
 * shared PAGES_ROUTES are consumed by customer-ui as well, which must keep its
 * current titles.
 */
@Injectable({ providedIn: 'root' })
export class SeoTitleStrategy extends TitleStrategy {
  private readonly seo = inject(SeoService);

  override updateTitle(state: RouterStateSnapshot): void {
    const data = deepestRoute(state.root).data;

    this.seo.update(
      {
        title: data['title'] as string | undefined,
        description: data['description'] as string | undefined,
        canonicalPath: data['canonicalPath'] as string | undefined,
        noindex: data['noindex'] === true,
      },
      state.url,
    );
  }
}

function deepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let current = route;
  while (current.firstChild) {
    current = current.firstChild;
  }
  return current;
}
